var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button-primary mx-2 py-1 rounded block",on:{"click":_vm.searchRoute}},[_vm._v(" "+_vm._s(_vm.$t('tour_plan_find_route'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }